import React from 'react';
import { observer } from 'mobx-react';

// Helpers
// import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import Dropzone from 'react-dropzone';
import EXIF from 'exif-js';

// Components
import EnrollValidate from '../Enroll/EnrollValidate';
import * as icons from '../Icons/Icons';

const EnrollPC = observer(class EnrollPC extends React.Component {
  constructor() {
    super();
    this.nextStep = this.nextStep.bind(this);
    this.setStep = this.setStep.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.acceptPhoto = this.acceptPhoto.bind(this);
    this.rejectPhoto = this.rejectPhoto.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUploaded = this.handleUploaded.bind(this);
    this.rotateImage = this.rotateImage.bind(this);
  }

  componentWillMount() {
    this.state = {
      step: 1,
      validating: false,
      idFront: null,
      idBack: null,
      headshot: null,
      pendingPhotos: [],
      acceptedPhotos: [],
      uploadedPhotos: [],
      idFrontUploaded: false,
      idBackUploaded: false,
      headshotUploaded: false,
      rotation: 0
    };
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  setStep(e, step) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step
    });
  }

  handleDrop(photo, name) {
    this.setState({
      [name]: photo,
      pendingPhotos: [name]
    });
  }

  acceptPhoto(name) {
    const { SessionStore } = this.props.store;
    let callback = null;
    let acceptedPhotos = [...this.state.acceptedPhotos];
    acceptedPhotos.push(name);

    this.setState({
      acceptedPhotos,
      pendingPhotos: []
    });

    // Convert preview image and send it
    const canvas = document.querySelector('.image-preview__canvas');
    const image = canvas.toDataURL('image/jpeg', .8);

    // Convert base64 to binary data
    const binaryString = atob(image.split(',')[1]);

    // Separate mime type
    const mimeString = image.split(',')[0].split(':')[1].split(';')[0];

    // Write the binary data to an ArrayBuffer
    const ab = new ArrayBuffer(binaryString.length);

    // Create a view into the buffer
    const ia = new Uint8Array(ab);

    // Set the binary data of the buffer to the correct values
    for(let i = 0; i < binaryString.length; i++) {
      ia[i] = binaryString.charCodeAt(i);
    }

    // Write the ArrayBuffer to a blob
    const blob = new Blob([ab], { type: mimeString });

    if(name === 'idFront') {
      // Submit front of id
      callback = () => this.handleUploaded('idFrontUploaded');
      this.props.store.SmarterIDStore.uploadSIDImage(blob, 'id-front', callback, this);
    } else if(name === 'idBack') {
      // Submit back of id
      callback = () => this.handleUploaded('idBackUploaded');
      this.props.store.SmarterIDStore.uploadSIDImage(blob, 'id-back', callback, this);
    } else {
      // Submit headshot
      callback = () => this.handleUploaded('headshotUploaded');
      this.props.store.SmarterIDStore.uploadSIDImage(blob, 'selfie', callback, this);
    }

    // If the last image is still uploading, show the loader
    if(
        this.state.idFront &&
        this.state.idBack &&
        this.state.headshot &&
        this.state.uploadedPhotos.length === 2
      ) {
      SessionStore.startLoading('Loading…', 'UploadedFinalPhoto');
    }
  }

  rejectPhoto(name) {
    let input = null;

    // Reset the hidden input field
    if(name === 'idFront') {
      input = document.querySelector('#enroll-id-front');
    } else if(name === 'idBack') {
      input = document.querySelector('#enroll-id-back');
    } else if(name === 'headshot') {
      input = document.querySelector('#enroll-headshot');
    }

    input.value = '';

    // Reset the state
    this.setState({
      [name]: null,
      pendingPhotos: []
    });
  }

  handleSubmit() {
    this.props.setStep(null, 5);
    this.props.setDisplayStep(3);
  }

  handleUploaded(name) {
    const { SessionStore } = this.props.store;
    let uploadedPhotos = [...this.state.uploadedPhotos];
    uploadedPhotos.push(name);

    this.setState({
      [name]: true,
      uploadedPhotos
    });

    this.nextStep();

    // Hide the loader if all images are uploaded
    if(this.state.uploadedPhotos.length === 3) {
      SessionStore.finishLoading('UploadedFinalPhoto');

      this.setState({
        validating: true
      });
    }
  }

  isActive(step) {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  previewImage(rotate, direction) {
    const _this = this;
    const image = document.querySelector('.image-preview');
    const canvas = document.querySelector('.image-preview__canvas');
    const ctx = canvas.getContext('2d');
    let orientation = null;

    EXIF.getData(image, function(){
      orientation = EXIF.getTag(this, 'Orientation');

      if(!orientation) {
        orientation = 1;
      }
    });

    const orientationDelay = setInterval(function(){
      if(orientation) {
        clearInterval(orientationDelay);

        let img = new Image();

        img.onload = function(){
          let imgWidth = img.width;
          let imgHeight = img.height;
          let ratio = 1;
          let maxSize = 2000;

          if(imgWidth > imgHeight && imgWidth > maxSize) {
            ratio = maxSize / imgWidth;
            imgWidth = maxSize;
            imgHeight *= ratio;
          } else if(imgHeight > imgWidth && imgHeight > maxSize) {
            ratio = maxSize / imgHeight;
            imgHeight = maxSize;
            imgWidth *= ratio;
          }

          // set proper canvas dimensions before transform & export
          if (orientation > 4 && orientation < 9) {
            canvas.width = imgHeight;
            canvas.height = imgWidth;
          } else {
            canvas.width = imgWidth;
            canvas.height = imgHeight;
          }

          // transform context before drawing image
          switch (orientation) {
            case 1:
              ctx.scale(ratio, ratio);
              break;

            case 2:
              ctx.transform(-1, ratio, ratio, 1, imgWidth, 0);
              break;

            case 3:
              ctx.scale(ratio, ratio);
              break;

            case 4:
              ctx.transform(1, ratio, ratio, -1, 0, imgHeight);
              break;

            case 5:
              ctx.transform(0, ratio, ratio, 0, 0, 0);
              break;

            case 6:
              ctx.transform(0, ratio, -ratio, 0, imgHeight, 0);

              if(!rotate) {
                _this.setState({
                  rotation: 90
                });
              }

              break;

            case 7:
              ctx.transform(0, -ratio, -ratio, 0, imgHeight, imgWidth);
              break;

            case 8:
              ctx.transform(0, -ratio, ratio, 0, 0, imgWidth);

              if(!rotate) {
                _this.setState({
                  rotation: -90
                });
              }

              break;

            default: break;
          }

          // draw the image
          ctx.drawImage(img, 0, 0);

          // If rotate button is clicked
          if(rotate) {
            // Clear the canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Make sure we’re rotating form the center
            ctx.translate(canvas.width / 2, canvas.height / 2);

            // Draw the image
            if(_this.state.rotation === 90 || _this.state.rotation === 270) {
              canvas.width = imgHeight;
              canvas.height = imgWidth;

              ctx.translate(imgHeight / 2, imgWidth / 2);
            } else {
              canvas.width = imgWidth;
              canvas.height = imgHeight;

              ctx.translate(imgWidth / 2, imgHeight / 2);
            }

            // Rotate the canvas
            ctx.rotate(_this.state.rotation * Math.PI / 180);

            // Draw the image
            if(_this.state.rotation === 90 || _this.state.rotation === 270) {
              ctx.drawImage(img, -imgWidth / 2, -imgHeight / 2, canvas.height, canvas.width);
            } else {
              ctx.drawImage(img, -imgWidth / 2, -imgHeight / 2, canvas.width, canvas.height);
            }
          }
        }

        img.src = image.src;
      }
    }, 100);
  }

  rotateImage(direction) {
    let rotation = 0;

    if(direction === 'right') {
      rotation = this.state.rotation + 90;
    } else {
      rotation = this.state.rotation - 90;
    }

    if(rotation === 360 || rotation === -360) {
      rotation = 0;
    }

    this.setState({
      rotation
    });

    const _this = this;

    setTimeout(function(){
      _this.previewImage(true, direction);
    });
  }

  render() {
    const { translation } = this.props;

    if(!this.state.validating) {
      return (
        <div className={this.props.isActive}>
          <div className="slide-wrap">
            {/* Front of ID */}
            <div className={`panel panel--brief ${this.isActive(1)}`}>
              <h2 className="panel__title">{translation.id_front_heading}</h2>

              <p>{translation.id_front}</p>

              <label className="btn" htmlFor="enroll-id-front">{translation.id_front_label}</label>

              <Dropzone
                className="file-hidden"
                onDrop={(photo) => this.handleDrop(photo, 'idFront')}
                multiple={false}
                accept={'image/*'}
                inputProps={{id: 'enroll-id-front', required: true}}
                disabled={this.state.idFront !== null}
              ></Dropzone>
            </div>

            {/* Back of ID */}
            <div className={`panel panel--brief ${this.isActive(2)}`}>
              <h2 className="panel__title">{translation.id_back_heading}</h2>

              <p>{translation.id_back}</p>

              <label className="btn" htmlFor="enroll-id-back">{translation.id_back_label}</label>

              <Dropzone
                className="file-hidden"
                onDrop={(photo) => this.handleDrop(photo, 'idBack')}
                multiple={false}
                accept={'image/*'}
                inputProps={{id: 'enroll-id-back', required: true}}
                disabled={this.state.idBack !== null}
              ></Dropzone>
            </div>

            {/* Headshot */}
            <div className={`panel panel--brief ${this.isActive(3)}`}>
              <h2 className="panel__title">{translation.headshot_heading}</h2>

              <p>{translation.headshot}</p>

              <label className="btn" htmlFor="enroll-headshot">{translation.headshot_label}</label>

              <Dropzone
                className="file-hidden"
                onDrop={(photo) => this.handleDrop(photo, 'headshot')}
                multiple={false}
                accept={'image/*'}
                inputProps={{id: 'enroll-headshot', required: true}}
                disabled={this.state.headshot !== null}
              ></Dropzone>
            </div>
          </div>

          {/* Image previews */}
          {this.state.pendingPhotos.map(
            (name, i) =>
            <div key={i} className="modal">
              {this.state[name] && this.state.acceptedPhotos.indexOf(name) < 0 &&
                <div className="modal__window">
                  {this.state[name].map(
                    (photo, i) =>
                    <div key={i} className="modal__image-wrap modal__image-wrap--dual">
                      <figure className="modal__image">
                        <figcaption className="modal__caption">{translation.example}</figcaption>

                        <img
                          src={`./static/img/${name}.jpg`}
                          alt="Example"
                        />
                      </figure>

                      <figure className="modal__image">
                        <figcaption className="modal__caption">{translation.yours}</figcaption>

                        <img
                          className="image-preview"
                          onLoad={() => this.previewImage(false)}
                          src={photo.preview}
                          alt="Yours"
                        />

                        <canvas className="image-preview__canvas"></canvas>

                        <div className="image-tools">
                          <span className="image-tools__heading">{translation.rotate}</span>

                          <ul className="pager">
                            <li className="pager__page">
                              <button
                                className="btn--link"
                                onClick={() => this.rotateImage('left')}
                              >
                                <span className="meta">{translation.rotate_counter}</span>
                                <icons.iconUndo />
                              </button>
                            </li>
                            <li className="pager__page">
                              <button
                                className="btn--link"
                                onClick={() => this.rotateImage('right')}
                              >
                                <span className="meta">{translation.rotate_clockwise}</span>
                                <icons.iconRedo />
                              </button>
                            </li>
                          </ul>
                        </div>
                      </figure>
                    </div>
                  )}

                  <div className="modal__content">
                    <p className="note">{translation.instructions[name]}</p>
                  </div>

                  <div className="modal__btns">
                    <button
                      className="btn btn--icn-right"
                      onClick={(e) => this.acceptPhoto(name)}
                    >
                      {translation.accept}
                      <icons.iconCheckCircle />
                    </button>

                    <span className="preposition--vertical">{translation.or}</span>

                    <button
                      className="btn--link"
                      onClick={(e) => this.rejectPhoto(name)}
                    >
                      {translation.retake}
                    </button>
                  </div>
                </div>
              }
            </div>
          )}
        </div>
      );
    } else {
      return (
        <EnrollValidate
          setPCStep={this.setStep}
          parent={this}
          {...this.props}
        />
      );
    }
  }
})

export default translate('EnrollPC')(EnrollPC);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/EnrollPC.js